import React from 'react'
import NavbarLayout from './NavbarLayout'

export default function WebsiteWrapper({children}) {
  return (
    <div>
      <NavbarLayout/>
      {children}
    </div>
  )
}
